'use client';

import { useRouter } from 'next/navigation';
import { useState, type FormEvent } from 'react';

import { SearchField } from '@eliadmin/core/src/components/dlz/home/stores/search-field';
import { NOT_FOUND_COPY } from '@eliadmin/core/src/components/dlz/not-found/not-found-copy';
import Link from '@eliadmin/core/src/components/link';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

const BUTTON = 'h-12 w-full md:h-[52px] md:w-auto';

/**
 * Figma „Search“ + „Actions“ of the 404 card: the search field opens the search page with the
 * typed term (Enter), then „Na domovskú stránku“ and „Kontaktovať podporu“ (contact page) – full
 * width on phones.
 */
export function NotFoundActions() {
  const { t } = useTranslations();
  const router = useRouter();
  const [query, setQuery] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    router.push(ROUTES.SEARCH(query.trim() || undefined));
  };

  return (
    <>
      <form role="search" aria-label={t('text211')} onSubmit={submit}>
        <SearchField label={NOT_FOUND_COPY.searchPlaceholder} value={query} onChange={setQuery} />
      </form>
      <div className="flex flex-col gap-3 md:flex-row">
        <Button asChild className={BUTTON}>
          <Link href={ROUTES.HOME()}>{NOT_FOUND_COPY.home}</Link>
        </Button>
        <Button asChild variant="secondary" className={BUTTON}>
          <Link href={ROUTES.CONTACT()}>{NOT_FOUND_COPY.support}</Link>
        </Button>
      </div>
    </>
  );
}
